module.exports = __webpack_public_path__ + "img/ascending.7f54ddf5.svg";